import React, { useEffect, useState } from "react";
import { Col, Table, Row, Image, Button } from "react-bootstrap";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import moment from "moment";
import CustomSuperAdminNotification from "../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import NewCountDown from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import EditWaitTime from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/EditWaitTime";
import AllActionPopup from "../AllActionPopup/AllActionPopup";
import EnterTableNumber from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/EnterTableNumber";
import isEmpty from "../../../../../store/validation/is-Empty";
import ShareButtonEventsTicket from "./ShareButtonEventsTicket";
import { useHistory } from "react-router-dom";
import CallingButtonPopup from "../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import ChatWindow from "../../../seatingDashboard/seatingDashboard/ChatWindow";
import SendSmsButton from "../../../../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../../../../reusableComponents/allPopupReusable/NotificationButton";
import CallingIconButtonActionFile from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";

const ViewRsvpOfflineEvent = (props) => {
  const history = useHistory();
  //state
  const [showLog, setShowLog] = useState(false);
  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [showView, setShowView] = useState(false);
  const handleCloseView = () => setShowView(false);
  const [state, setState] = useState({
    code: "",
    open: false,
  });

  const onCloseModal = () => {
    setState({
      ...state,
      open: !state.open,
    });
  };

  const handleShowView = () => {
    setShowView(true);
  };
  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };

  useEffect(() => {
    if (props?.defaultOpen) {
      handleShowView();
      if (props?.setOpenFalse) {
        props.setOpenFalse(false);
      }
    }
  }, [props?.defaultOpen]);
  // const [checkedBox, setCheckedBox] = useState(false);
  // const handleChangeSwitch = (e) =>
  //   setCheckedBox({ checkedBox: !checkedBox.checkedBox });

  /*******************************
   * @DESC Pending Total Wait time
   *******************************/
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props?.dataSend?.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convertPending(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  /*******************************
   * @DESC Seating Total Wait time
   *******************************/
  const seatedTime = new Date(props?.dataSend?.seatedTime);
  const updatedAt = new Date(props?.dataSend?.updatedAt);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  var updatedTimeNew = moment(updatedAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);
  let dataThreeSeated = new Date(updatedTimeNew);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let totalUpdatedTime = dataThreeSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);
  let minutesUpdatedTime = Math.floor(totalUpdatedTime / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " HH : " + nMinutesSeated + " min";
  }

  function upated_time_difference(minutesUpdatedTime) {
    var hours = Math.floor(minutesUpdatedTime / 60);
    var nMinutesUpdatedTime = minutesUpdatedTime % 60;
    return hours + " HH : " + nMinutesUpdatedTime + " min";
  }

  const updatedTime = new Date(
    props?.dataSend?.wait_time_date || props?.dataSend?.updatedAt
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNewDiff = updatedTime.getTime();
  const waitTime = Math.abs(props?.dataSend?.wait_time) * 60 * 1000;
  let updateWaitTime = updatedTimeNewDiff + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowView}
      >
        <Image
          src={require("../../../../../assets/images/UserManagement/eye.svg")}
          alt="View"
          title="View"
          fluid
        />
      </Button>

      <Modal
        open={showView}
        onClose={handleCloseView}
        // show={showView} onHide={handleCloseView}
        // centered
        // size="xl"
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled dark-backdrop",
          modal: "customModal-view-action-event",
          closeButton: "customCloseButtonCalling",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        {/* <Modal.Header className="border-0 px-md-4" closeButton> */}
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="f24-700">View Event Details</h5>
          <i
            className="fa fa-times"
            aria-hidden="true"
            onClick={handleCloseView}
          ></i>
        </div>

        {/* </Modal.Header> */}
        <div>
          {/* {console.log("Test Data =>", props.dataSend)} */}
          <div
            className={`enGrayBorderBox mb-4`}
            // ${
            //   props?.dataSend?.service_type === "RESERVATION"
            //     ? "enLeftYellowLine"
            //     : "enLeftGReenLine"
            // }
          >
            <Row className="px-3">
              <Col
                lg={4}
                md={6}
                className="py-3 d-flex justify-content-between"
              >
                <div>
                  <div className="f12-500 pb-3">Req. Type</div>
                  {props?.dataSend?.event_type === "RSVP" ? (
                    <Image
                      src={require("../../../../../assets/images/seatingImages/happy-new-year.svg")}
                      alt="Order Type"
                      title="Order Type"
                      className="img-fluid"
                      style={{ width: 28 }}
                    />
                  ) : null ||
                    props?.dataSend?.event_type === "TICKET_BOOKED" ? (
                    <Image
                      src={require("../../../../../assets/images/seatingImages/movie-seat.svg")}
                      alt="Order Type"
                      title="Order Type"
                      className="img-fluid"
                      style={{ width: 28 }}
                    />
                  ) : null}
                </div>
                <div>
                  <div className="f12-500 pb-3">Name/Request Number</div>
                  <div className="d-flex">
                    <div>
                      {/* <Image
                        src={require("../../../../../assets/images/UserManagement/walkin.svg")}
                        alt="View"
                        title="View"
                        width="9px"
                      /> */}
                    </div>
                    <div className="pl-2">
                      <div className="f15-500">
                        {props?.dataSend?.user_details?.name}
                      </div>
                      <div className="f9-400">
                        #{props?.dataSend?.event_request_id}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={2} md={6} className="py-3">
                <div className="f12-500 pb-3">Total PAX</div>
                <div className="adult-total-box">
                  <div className="d-flex align-items-center">
                    <p className="f18-700 text-dark mr-2">
                      {props?.dataSend?.adult_count +
                        props?.dataSend?.kids_count}
                    </p>
                    <div className="adult-total-box-two mr-2">
                      {props?.dataSend?.adult_count === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/employees.png")}
                              fluid
                              alt="Adult"
                              title="Adult"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">
                            {props?.dataSend?.adult_count}
                          </span>
                        </div>
                      )}
                      {props?.dataSend?.kids_count === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/children.png")}
                              fluid
                              alt="Children"
                              title="Children"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">
                            {props?.dataSend?.kids_count}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="adult-total-box-three">
                      {props?.dataSend?.handicap_chair === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/highchair.png")}
                              fluid
                              alt="Highchair"
                              title="Highchair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">
                            {props?.dataSend?.handicap_chair}
                          </span>
                        </div>
                      )}
                      {props?.dataSend?.high_chair === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                              fluid
                              alt="Wheel Chair"
                              title="Wheel Chair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">
                            {props?.dataSend?.high_chair}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Date / Time / Timer</div>
                <div className="f18-700 text-red d-flex align-items-center">
                  <div className="timer-section mr-2">
                    <h4 className="timer-count f14-500 text-red">
                      <NewCountDown waitNew={diff} />
                    </h4>
                  </div>
                  {/* {props?.dataSend?.event_status === "REJECTED" ||
                  props?.dataSend?.event_status === "CANCELLED" ||
                  props?.dataSend?.event_status === "COMPLETED" ? (
                    ""
                  ) : (
                    <EditWaitTime
                      allDataProps={props?.dataSend?._id}
                      actionBy="RsvpEvent"
                      status={props.dataSend}
                    />
                  )} */}
                </div>
                <div className="f12-400">
                  {moment(props.dataSend && props?.dataSend?.updatedAt).format(
                    "Do MMM, YYYY"
                  )}
                </div>
                <div className="f12-400">
                  {moment(props.dataSend && props?.dataSend?.updatedAt).format(
                    "hh:mm A"
                  )}
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Seating Preference</div>
                <div className="d-flex flex-wrap">
                  {props.dataSend &&
                  props?.dataSend?.seating_preference?.length <= 0
                    ? "_"
                    : props?.dataSend?.seating_preference?.length > 0 &&
                      props?.dataSend?.seating_preference.map((seat, index) => {
                        return (
                          <React.Fragment key={index}>
                            <p>{seat}</p>
                          </React.Fragment>
                        );
                      })}
                </div>
              </Col>
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Date & Time</div>
                <div className="f12-400">
                  {moment(props?.dataSend?.createdAt).format("Do MMMM YYYY")}
                </div>
                <div className="f12-400">
                  {moment(props?.dataSend?.createdAt).format("hh:mm A")}
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3" style={{ cursor: "no-drop" }}>
                {!props?.admin && (
                  <>
                    <div className="f12-500 pb-3">
                      Track User
                      <br />
                      Location
                    </div>
                    <div className="ml-4">
                      <Image
                        fluid
                        src={require("../../../../../assets/images/ActionImages/maps-and-flagsred.png")}
                        alt="Location Icon"
                        width="13px"
                        title="Location"
                      />
                    </div>
                  </>
                )}
              </Col>
              <Col lg={6} md={6} className="py-3">
                {props?.admin ? (
                  <div className="middle-timer ml-4 mr-4">
                    <p className="f12-400">Total Wait time</p>
                    <div className="count-down-timer d-flex mt-2 mb-2">
                      <i
                        className="fa fa-hourglass-half mr-3"
                        aria-hidden="true"
                      ></i>
                      <p className="font_16_m">
                        {props?.dataSend?.event_status === "NOTSEATED"
                          ? time_convertPending(minutes)
                          : seated_time_difference(minutesSeated)}
                      </p>
                    </div>
                    {/* <p className="font_20_r">
                      Status:&nbsp;
                      <span className="font_20_b">
                        
                        {props?.dataSend?.event_status}
                      </span>
                    </p> */}
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center">
                    {props.pathname === "/offline-events-rsvp" &&
                    props?.dataSend?.event_status === "PENDING" ? (
                      <AllActionPopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="resonFforCancellation"
                        actionCall={"rsvpReject"}
                        buttonText="Reject"
                        bigText="Request Reject"
                        reasonText="Are you sure to Reject ?"
                        dataSend={props.dataSend}
                      />
                    ) : props.pathname === "/offline-events-rsvp" &&
                      props?.dataSend?.event_status === "NOTSEATED" ? (
                      <AllActionPopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="resonFforCancellation"
                        actionCall="rsvpCancel"
                        buttonText="Cancel"
                        bigText="Request Cancel"
                        reasonText="Are you sure to Cancel ?"
                        dataSend={props.dataSend}
                      />
                    ) : props.pathname === "/offline-events-rsvp" &&
                      props?.dataSend?.event_status === "SEATED" ? (
                      <AllActionPopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="seatingUnseated"
                        buttonText="Unseat"
                        bigText="Request Unseat"
                        display={true}
                        reasonText="Are you sure to Unseat ?"
                        dataSend={props.dataSend}
                        // subscription_id={props.subscription_id}
                      />
                    ) : (props.pathname === "/offline-events-rsvp" &&
                        props?.dataSend?.event_status === "COMPLETED") ||
                      (props.pathname === "/offline-events-rsvp" &&
                        props?.dataSend?.event_status === "REJECTED") ||
                      (props.pathname === "/offline-events-rsvp" &&
                        props?.dataSend?.event_status === "CANCELLED") ? (
                      <AllActionPopup
                        buttonDisplay="smallCancelButton"
                        displayPopup="historyReset"
                        buttonText="Reset"
                        bigText="Request Reset"
                        reasonText="Are you sure to Reset ?"
                        dataSend={props.dataSend}
                        // subscription_id={props.subscription_id}
                      />
                    ) : null}
                    <div className="middle-timer ml-4 mr-4">
                      <p className="f12-400 text-center ">Total Wait time</p>
                      <div className="count-down-timer d-flex mt-2 mb-2">
                        <i
                          className="fa fa-hourglass-half mr-3"
                          aria-hidden="true"
                        ></i>
                        <p className="font_16_m">
                          {props?.dataSend?.event_status === "NOTSEATED"
                            ? time_convertPending(minutes)
                            : seated_time_difference(minutesSeated)}
                        </p>
                      </div>
                      <p className="font_20_r">
                        Status:&nbsp;
                        <span className="font_20_b">
                          {/* {props?.dataSend?.diner_status === "NOTSEATED"
                              ? "NOT SEATED"
                              : "SEATED"} */}
                          {props?.dataSend?.event_status}
                        </span>
                      </p>
                    </div>
                    {props.pathname === "/offline-events-rsvp" &&
                    props?.dataSend?.event_status === "PENDING" ? (
                      // <AllActionPopup
                      //   buttonDisplay="acceptButtonReservation"
                      //   // displayPopup="acceptButtonReservation"
                      //   buttonText="Accept"
                      //   bigText="Request Accept"
                      //   reasonText="Are you sure you want to accept ?"
                      //   dataSend={props.dataSend}
                      // />

                      // <EditWaitTime
                      //   buttonText="Accept"
                      //   editButtonStatus="pendingEdit"
                      //   closedMainModal={onCloseModal}
                      //   allDataProps={props?.dataSend?._id}
                      // />
                      <AllActionPopup
                        buttonDisplay="acceptButtonReservation"
                        // displayPopup="acceptButtonReservation"
                        actionButton="acceptPendingButton"
                        diffrenceTime={diff}
                        buttonText="Accept"
                        bigText="Request Accept"
                        reasonText="Are you sure you want to accept ?"
                        dataSend={props.dataSend}
                      />
                    ) : props.pathname === "/offline-events-rsvp" &&
                      props?.dataSend?.event_status === "NOTSEATED" ? (
                      <EnterTableNumber
                        buttonText="Seat"
                        actionBy="RsvpTable"
                        eventId={props.dataSend}
                        closedMainModal={onCloseModal}
                        allDataProps={props.dataSend}
                      />
                    ) : props.pathname === "/offline-events-rsvp" &&
                      props?.dataSend?.event_status === "SEATED" ? (
                      <AllActionPopup
                        buttonDisplay="seatingCompleted"
                        displayPopup="seatingCompleted"
                        buttonText="Complete"
                        bigText="Request Complete"
                        reasonText="Are you sure to Completed ?"
                        dataSend={props.dataSend}
                        // subscription_id={props.subscription_id}
                      />
                    ) : null}
                  </div>
                )}
                {/* <p className="f12-400 text-center">Total Wait time</p>
                <div className="d-flex justify-content-center align-items-center">
                  <button className="btn btn-danger enWidth75" type="button">
                    Cancel
                  </button>
                  <div className="px-2">
                    <div className="enTimesLbl d-flex justify-content-center align-items-center">
                      <Image
                        src={require("../../../../../assets/images/UserManagement/hourglass.svg")}
                        alt="Edit"
                        title="Edit"
                        width="10px"
                      />
                      <p className="f10-500 text-dark pl-2">
                        {" "}
                        {props?.dataSend?.diner_status === "PENDING" ||
                        props?.dataSend?.diner_status === "NOTSEATED"
                          ? time_convertPending(minutes)
                          : props?.dataSend?.diner_status === "SEATED" ||
                            props?.dataSend?.diner_status === "COMPLETED"
                          ? seated_time_difference(minutesSeated)
                          : props?.dataSend?.diner_status === "REJECTED" ||
                            props?.dataSend?.diner_status === "CANCELLED"
                          ? upated_time_difference(minutesUpdatedTime)
                          : null}
                      </p>
                    </div>
                  </div>
                  <button className="btn btn-success enWidth75" type="button">
                    Seat
                  </button>
                </div> */}
              </Col>
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
              <Col lg={3} md={6} className="py-3">
                {!props?.admin && (
                  <div className="d-flex flex-wrap align-items-center py-3 enWidth130">
                    <div className="mb-3">
                      {/* <CallingButtonPopup
                        buttonClass="smallButton"
                        sendData={props.dataSend}
                      /> */}
                      <CallingIconButtonActionFile
                        orderDetails={props?.dataSend?.user_details}
                        actionType="conbinedName"
                      />
                    </div>
                    <div className="mb-3">
                      <ChatWindow data={props.dataSend} text={"event"} />
                    </div>
                    <SendSmsButton
                      dataSend={props.dataSend}
                      buttonClass="smallButton"
                      actionBy="RsvpEvent"
                    />
                    <NotificationButton
                      buttonClass="smallButton"
                      dataSend={props.dataSend}
                      actionBy="RsvpEvent"
                    />
                    <ShareButtonEventsTicket
                      data={props?.dataSend}
                      dataProps={props?.dataProps}
                    />
                    <Button
                      variant="link"
                      className="enIconBtn ml-3"
                      style={{ color: "black" }}
                      onClick={() => {
                        // history.push(`/ticketbooked/${props?.dataSend?._id}`);
                        const win = window.open(
                          `/ticketbooked/${props?.dataSend?._id}`,
                          "_blank"
                        );
                        win.focus();
                      }}
                    >
                      <i class="fa fa-print" aria-hidden="true"></i>
                    </Button>
                  </div>
                )}
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Seat / Room No.</div>
                <div className="f12-400 d-flex">
                  Seat No. -{" "}
                  {props?.dataSend?.seat_number?.length > 0 &&
                    props?.dataSend?.seat_number.map((data, index) => {
                      return (
                        <React.Fragment key={index}>
                          <div className="f12-400">{data},&nbsp;</div>
                        </React.Fragment>
                      );
                    })}
                  {/* {props?.dataSend?.table_number} */}
                </div>
                <div className="f12-400">
                  Room No. - {props?.dataSend?.room_number}
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Special Occasion</div>
                <div className="f12-400">{props?.dataSend?.occasion}</div>
                {/* <Button variant="link" className="text-red f12-400 p-0">
                  See more
                </Button> */}
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Status / Location</div>
                <div className="f13-400">
                  <span className="enYellowDot mr-1"></span>
                  {props?.dataSend?.event_status}
                </div>
              </Col>
            </Row>
          </div>
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              Details
              <Image
                src={require("../../../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-3">
                <Col lg={4} md={4} className="py-3">
                  <div className="f12-500 pb-3">Phone Number</div>
                  <div className="f15-700 pb-3">
                    {props?.dataSend?.user_details?.country_code +
                      " " +
                      props?.dataSend?.user_details?.mobile_number}
                  </div>
                </Col>
                <Col lg={4} md={4} className="py-3">
                  <div className="f12-500 pb-3">Request Number</div>
                  <div className="f15-700 pb-3">
                    #{props?.dataSend?.event_request_id}
                  </div>
                </Col>
                <Col lg={4} md={4} className="py-3">
                  <div className="f12-500 pb-3">User status</div>
                  <div className="f15-700 pb-3">
                    {props?.dataSend?.user_id?.user_verified !== undefined &&
                    props?.dataSend?.user_id?.user_verified !== null
                      ? props?.dataSend?.user_id?.user_verified === true
                        ? "Confirmed by User"
                        : "Not Confirmed by User"
                      : "-"}
                  </div>
                </Col>
              </Row>
              <hr className="m-0" />
              <Row className="px-3">
                {/* <Col lg={4} md={4} className="py-3">
                  <div className="f12-500 pb-3">Requested date/time</div>
                  <div className="f15-700">
                    {props?.dataSend?.service_type === "SEATING"
                      ? ""
                      : moment(props?.dataSend?.reservationTime).format(
                          "Do MMMM YYYY"
                        )}
                  </div>
                  <div className="f15-700">
                    {props?.dataSend?.service_type === "SEATING"
                      ? ""
                      : moment(props?.dataSend?.reservationTime).format(
                          "hh:mm A"
                        )}
                  </div>
                </Col>
                <Col lg={4} md={4} className="py-3">
                  <div className="f12-500 pb-3">Created date/time</div>
                  <div className="f15-700">
                    {moment(props?.dataSend?.createdAt).format("Do MMMM YYYY")}
                  </div>
                  <div className="f15-700">
                    {moment(props?.dataSend?.createdAt).format("hh:mm A")}
                  </div>
                </Col> */}
                <Col lg={4} md={4} className="py-3">
                  <div className="f12-500 pb-3">Changed date/time</div>
                  <div className="f15-700">
                    {moment(props?.dataSend?.updatedAt).format("Do MMMM YYYY")}
                  </div>
                  <div className="f15-700">
                    {moment(props?.dataSend?.updatedAt).format("hh:mm A")}
                  </div>
                </Col>
                <Col lg={4} md={4} className="py-3">
                  <div className="f12-500 pb-3">Point of entry</div>
                  <div className="f15-700">{props?.dataSend?.pointOfEntry}</div>
                </Col>
              </Row>
              <hr className="m-0" />
              <Row className="px-3">
                <Col lg={8} md={8} className="py-3">
                  <div className="f12-500 pb-3">Reason for cancellation</div>
                  <div className="f15-700">{props?.dataSend?.cancelReason}</div>
                </Col>
              </Row>
            </div>
          )}
          <hr className="mt-4 mb-4" />
          <div className="f18-700 px-0 pb-3 text-dark">Payment Details</div>
          <div className="enGrayBorderBox">
            <Row className="px-3">
              <Col lg={3} md={3} className="py-3">
                {/* {console.log("Data event ====>", props.dataSend)} */}
                <div className="f12-500 pb-3">Transaction ID</div>
                <div className="f15-700 pb-3">
                  {props.dataSend?.event_type === "TICKET_BOOKED"
                    ? props.dataSend?.transactional_id !== undefined
                      ? props.dataSend?.transactional_id
                      : "N/A"
                    : "N/A"}
                </div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Payment Method</div>
                <div className="f15-700 pb-3">
                  {props.dataSend?.event_type === "TICKET_BOOKED"
                    ? props?.dataSend?.payment_data !== undefined &&
                      props?.dataSend?.payment_data !== null
                      ? props?.dataSend?.payment_data.payment_method === 0
                        ? "CASH"
                        : props?.dataSend?.payment_data.payment_method === 1
                        ? "UPI"
                        : props?.dataSend?.payment_data.payment_method === 2
                        ? "PAYTM"
                        : props?.dataSend?.payment_data.payment_method === 3
                        ? "DEBIT CARD"
                        : props?.dataSend?.payment_data.payment_method === 4
                        ? "CREDIT CARD"
                        : props?.dataSend?.payment_data.payment_method === 5
                        ? "NETBANKING"
                        : props?.dataSend?.payment_data.payment_method === 6
                        ? "PAY LATER"
                        : props?.dataSend?.payment_data.payment_method === 7
                        ? "WALLET"
                        : props?.dataSend?.payment_data.payment_method === 8
                        ? "EXTERNAL WALLET"
                        : props?.dataSend?.payment_data.payment_method === 9
                        ? "CASH"
                        : null
                      : "N/A"
                    : "N/A"}
                </div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Payment Status</div>
                <div className="f15-700 pb-3">
                  {props.dataSend?.payment_status === 0
                    ? "PENDING"
                    : props?.dataSend?.payment_status === 1
                    ? "COMPLETED"
                    : props?.dataSend?.payment_status === 2
                    ? "CANCELLED"
                    : props?.dataSend?.payment_status === 3
                    ? "FAILURE"
                    : props?.dataSend?.payment_status === 4
                    ? "REVERSED"
                    : null}
                </div>
              </Col>
              <Col lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Payment Date / Time</div>
                <div className="f15-700 pb-3">
                  {moment(new Date()).format("Do MMMM YYYY")}
                </div>
              </Col>
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
              {props.dataSend?.payment_data?.total_amount ===
                props.dataSend?.payment_data?.oldAmount && (
                <Col lg={3} md={3} className="py-3">
                  <div className="f12-500 pb-3">Amount</div>
                  <div className="f15-700">
                    {props.dataSend?.event_type === "TICKET_BOOKED"
                      ? props.dataSend?.payment_data?.total_amount !== undefined
                        ? `₹ ${props.dataSend?.payment_data?.total_amount}`
                        : "N/A"
                      : "N/A"}
                  </div>
                </Col>
              )}
              {props.dataSend?.payment_data?.total_amount !==
                props.dataSend?.payment_data?.oldAmount && (
                <>
                  <Col lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3">Amount Paid</div>
                    <div className="f15-700">
                      {props.dataSend?.event_type === "TICKET_BOOKED"
                        ? props.dataSend?.payment_data?.total_amount !==
                          undefined
                          ? `₹ ${props.dataSend?.payment_data?.total_amount}`
                          : "N/A"
                        : "N/A"}
                    </div>
                  </Col>
                  <Col lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3">Original Amount</div>
                    <div className="f15-700">
                      {props.dataSend?.event_type === "TICKET_BOOKED"
                        ? props.dataSend?.payment_data?.oldAmount !== undefined
                          ? `₹ ${props.dataSend?.payment_data?.oldAmount}`
                          : "N/A"
                        : "N/A"}
                    </div>
                  </Col>
                </>
              )}
            </Row>
          </div>
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <thead>
                  <tr>
                    <th className="">
                      <div className="f12-500">Date</div>
                    </th>
                    <th>
                      <div className="f12-500">Operation</div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(props?.dataSend?.auditLogs) &&
                    props?.dataSend?.auditLogs.map((data, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>
                              <div className="f12-500">
                                {moment(data.timestamp).format("Do-MMM-YYYY")}
                              </div>
                              <div className="f12-500">
                                {moment(data.timestamp).format("hh:mm A")}
                              </div>
                            </td>
                            <td>
                              <div className="f12-500">{data.message}</div>
                            </td>
                            <td>
                              <div className="f12-500">{data.initiator}</div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};
export default ViewRsvpOfflineEvent;
